import { defineClientModule } from '../client-module';

export const websitesModule = defineClientModule({
  id: 'websites', recordTypeKey: 'website', label: 'Websites', route: '/websites', navGroup: 'Workspace', icon: 'Globe',
  description: 'The websites One Up builds, hosts, and maintains for you.', view: 'websites',
  emptyState: {
    title: 'No websites yet.',
    body: 'Once a site is linked to your organization it appears here with its status, hosting details, and a live preview.',
  },
});

/**
 * Tasks and projects.
 *
 * The nav lands on `/work/tasks`: day-to-day work items are what a client
 * actually checks, and projects are the roll-up above them. `/work` and
 * `/work/projects` still resolve, so existing links and bookmarks keep working.
 */
export const workModule = defineClientModule({
  id: 'work', recordTypeKey: 'task', label: 'Tasks & Projects', route: '/work/tasks', navRoute: '/work/tasks',
  navGroup: 'Workspace', icon: 'ClipboardList',
  description: 'What One Up is actively working on for your organization.', view: 'work',
  emptyState: {
    title: 'No open work right now.',
    body: 'Active tasks and projects for your organization show up here as soon as they are underway.',
  },
});

export const invoicesModule = defineClientModule({
  id: 'invoices', recordTypeKey: 'invoice', label: 'Invoices', route: '/invoices', navGroup: 'Billing', icon: 'Receipt',
  description: 'Every invoice raised for your organization, with balances and receipts.',
  view: 'invoices',
  source: { endpoint: '/api/client/invoices', tableKey: 'invoices' },
  clientSafeFields: [
    'Invoice ID', 'Invoice Status', 'Amount Due (raw)', 'Amount Paid (raw)', 'Created Date',
    'Finalized Date', 'Paid Date', 'Stripe Hosted URL', 'Invoice PDF', 'Stripe Invoice Number',
    'Type Of Invoice',
  ],
  emptyState: {
    title: 'No invoices yet.',
    body: 'Invoices raised for your organization appear here, along with what has been paid and what is outstanding.',
  },
});

export const subscriptionsModule = defineClientModule({
  id: 'subscriptions', recordTypeKey: 'subscription', label: 'Subscriptions', route: '/subscriptions', navGroup: 'Billing',
  icon: 'RefreshCw',
  description: 'The recurring plans and retainers active on your account.',
  view: 'subscriptions',
  source: { endpoint: '/api/client/subscriptions', tableKey: 'subscriptions' },
  clientSafeFields: [
    'Subscription Status', 'Products', 'Price', 'price with discount', 'Interval',
    'Next Invoice Date', 'Current Period End Friendly', 'Billing Category', 'Notes',
    'ENT_Websites', 'Ai_Agents', 'Invoices',
  ],
  emptyState: {
    title: 'No subscriptions on file.',
    body: 'Recurring plans and retainers appear here with their price, billing interval, and renewal date.',
  },
});

export const formsModule = defineClientModule({
  id: 'forms', recordTypeKey: 'form_entry', label: 'Form Entries', route: '/forms', navRoute: '/forms/entries', navGroup: 'Workspace', icon: 'FileText',
  description: 'Enquiries and leads captured from your website forms.', view: 'forms',
  emptyState: {
    title: 'No form submissions yet.',
    body: 'Enquiries submitted through your website forms land here, newest first.',
  },
});

export const docsModule = defineClientModule({
  id: 'docs', recordTypeKey: 'vault_document', label: 'Docs', route: '/docs', navGroup: 'Knowledge', icon: 'BookOpenCheck',
  description: 'Guides, policies, and how-to material published to your organization.', view: 'docs',
  emptyState: {
    title: 'No documents published yet.',
    body: 'Guides and reference material One Up publishes to your organization will appear here.',
  },
});
